import { createFileRoute } from "@tanstack/react-router";
import { PrjTmplListPage } from "@client/components/workflow-tmpl/prj-tmpl-list-page";

export const Route = createFileRoute("/_app/projects/templates/")({
  component: PrjTmplListPage,
});
